export const taboolaMixins: Record<string, Partial<TaboolaProps>> = {
  newtab_r1_c2: {
    containerName: 'taboola-homepage-r1-c2',
    mode: 'thumbnails-r-267x178-v2',
  },
  newtab_r1_topright: {
    containerName: 'taboola-homepage-r1-topright',
    mode: 'thumbnails-r-267x178-v2',
  },
  newtab_r2_c1: {
    containerName: 'taboola-homepage-r2-c1',
    mode: 'thumbnails-r-267x178-v2',
  },
  newtab_r3_right: {
    containerName: 'taboola-homepage-r3',
    mode: 'thumbnails-r-267x178-v2',
  },
  newtab_r4_c1: {
    containerName: 'taboola-homepage-r4-c1',
    mode: 'thumbnails-r-267x178-v2',
  },
  newtab_r4_right: {},
  newtab_endless_native: {
    containerName: 'taboola-homepage-d-',
    mode: 'thumbnails-r-267x178-v2',
  },

  //Article placements
  article_siderail_middle: {
    mode: 'thumbnails-a-stream',
    containerName: 'taboola-right-rail---8',
  },
  article_native_below_article_feed: {
    mode: 'alternating-thumbnails-a',
    containerName: 'taboola-below-article-feed',
  },
  article_content_below_button: {
    mode: 'alternating-thumbnails-a',
    containerName: 'taboola-below-article-feed',
  },
}
